export enum ERoomType {
	GROUP_CHAT = 'group',
	ONE_ON_ONE = '1o1'
}

export interface Room {
	_id: string;
	hostRoomId?: string;
	hostId: number;
	hostName: string;
	title: string;
	tags: string[];
	parentRoomId?: string;
	thumbnail?: string;
	priorityOrder?: number;
	badge?: {
		icon?: string;
		bgUrl?: string;
		text: string;
	};
	membersAllowed?: number;
	speakersAllowed?: number;
	initialEntryFee?: number;
	timeAllowedForSpeaker?: number;
	currencyType?: 'INR' | 'COINS' | 'CASH';
	isActive?: boolean;
	hostProfilePic?: string;
	bio?: string;
	pinnedMessageByHost?: string;
	uid?: string;
	tncUpdatedTimestamp?: number;
	segmentNames?: string[];
	languages?: string[];
	charges?: number;
	durationInMinutes?: number;
	roomType?: ERoomType;
}

export interface CreateRoomData {
	hostId: string;
	referralCode: string;
	hostName: string;
	title: string;
	tags: string;
	thumbnail: string;
	priorityOrder: string;
	badgeIcon: string;
	badgeText: string;
	membersAllowed: string;
	speakersAllowed: string;
	initialEntryFee: string;
	timeAllowedForSpeaker: string;
	currencyType: string;
	segmentNames: string;
	languages: string[];
	charges: string;
	durationInMinutes: string;
	roomType: string;
}

export interface ApiResponse<T> {
	success: boolean;
	data: T;
	error?: string;
}

export interface RoomsListResponse {
	rooms: Room[];
	totalCount: number;
}

export interface CreateRoomResponse {
	roomId: string;
	message: string;
}

export interface UpdateRoomData {
	_id: string;
	hostRoomId: string;
	hostId: string;
	hostName: string;
	title: string;
	tags: string;
	bio: string;
	priorityOrder: string;
	badgeIcon: string;
	badgeText: string;
	segmentNames: string;
	languages: string[];
	charges: string;
	durationInMinutes: string;
}

export interface UpdateRoomResponse {
	success: boolean;
	data?: Room | null;
	message?: string;
}
